import React from 'react'
import Product from '../components/Product'
import { products } from '../data';

import { Link, useLocation, useParams } from 'react-router-dom';
import BigAd from '../components/BigAd';
import { HomePath } from '../home-path'

export default function Details() {
    const location = useLocation();
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
    const data = location.state;
    const { id } = useParams();
    // console.log(id)
    const singleProduct = products?.filter(item => item?.id == id);
    // console.log('temp product', singleProduct);

  return (
    <>
    <div className="min-h-screen w-full py-12">
        <div className="mxw">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 pb-12">
                <div className="h-fit py-4 space-y-4">
                    <div className="space-y-2">
                        <p className="text-lg md:text-xl capitalize text-gray-500">{singleProduct[0]?.sex} {singleProduct[0]?.type}</p>
                        <p className="font-bold text-xl md:text-2xl lg:text-3xl capitalize">{singleProduct[0]?.name}</p>
                        <p className=" text-lg md:text-xl lg:text-2xl font-bold">${singleProduct[0]?.price}</p>
                    </div>
                    
                    <p className="text-md md:text-lg lg:text-xl">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Expedita aperiam unde, alias pariatur, est inventore velit tempora corrupti commodi ducimus blanditiis accusamus quod voluptate facere adipisci eaque atque. Debitis, laborum.</p>
                    <ul className="list-disc list-inside text-md md:text-lg text-gray-600">
                        <li className="pl-6">Shown: black / white</li>
                        <li className="pl-6">Size: XL</li>
                        <li className="pl-6">Country of Origin: Canada</li>
                    </ul>
                    <Link className="mt-4 inline-block" to={HomePath + `/product/${singleProduct[0]?.id}/product-details`} state={data}>
                        <button className="py-2 px-3 rounded-full border">
                            <span>View product details</span>
                        </button>
                    </Link>
                </div>
                <div className="h-96 md:h-[500px] w-lg">
                    <img className="h-full w-full object-cover shadow-xl" src={singleProduct[0]?.img} alt="" />
                </div>
            </div>
            <div className="max-w-sm  mx-auto w-full h-fit py-4 space-y-4">
                <div className="flex flex-col space-y-4">
                    <button className="flex items-center justify-center space-x-2 py-2 px-3 border border-gray-700 rounded-3xl hover:bg-black hover:text-white duration-300">
                        <span>Select Size</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
                        </svg>
                    </button>
                    <Link to={HomePath + "/cart"}>
                        <button className="inline-flex items-center justify-center space-x-2 w-full py-2 px-3 border border-gray-700 rounded-3xl bg-black text-white duration-300">
                            <span>Add to bag</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                            </svg>
                        </button>
                    </Link>
                    <button className="flex items-center space-x-2 justify-center py-2 px-3 border border-gray-700 rounded-3xl hover:bg-black hover:text-white duration-300">
                        <span>Favourite</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                        </svg>
                    </button>
                </div>
            </div>
            <div className="w-full space-y-4 mt-4">
                {/* size */}
                <p className="font-bold">Size and fit</p>
                <ul className="list-disc list-inside">
                    <li className="pl-6">Standard Fit: Easy and Traditional</li>
                </ul>
                {/* reviews */}
                <p className="font-bold">Reviews(1)</p>
                <ul className="list-disc list-inside">
                    <li className="pl-6">Good Fit. Worth for it's price.</li>
                </ul>
                {/* manufacturing */}
                <p className="font-bold">Manufacturing &amp; Import Info</p>
                <p>Declaration of the Imported: Direct import by the individual customer</p>
                <p>Marketed by: Median.co Canada</p>

                {/* share */}
                <div className="max-w-sm mx-auto w-full h-fit py-4 space-y-4">
                    <div className="flex flex-col space-y-4">
                        <button className="flex items-center justify-center space-x-2 py-2 px-3 border border-gray-700 rounded-3xl hover:bg-black hover:text-white duration-300">
                            <span>Share</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
                            </svg>
                        </button>
                    </div>
                </div>
                <p className="text-gray-500 text-md :text-lg lg:text-xl py-4"><span className="text-black font-medium">Promotional Text</span>: Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita molestiae inventore sit.</p>

                {/* product */}
                <div className="grid gap-2 md:gap-4 col-span-1 lg:grid-cols-4">
                    <div className="col-span-2 grid grid-cols-4 gap-2 md:gap-4 grid-rows-1">
                        <div className="col-span-2">
                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>
                        </div>
                        <div className="col-span-2">
                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>
                        </div>
                    </div>
                    <div className="col-span-2">
                        <BigAd minorHeading="Seasonal Sale!" majorHeading="Shop the Holidays!" text="While supplies last!" route={HomePath + "/shop"} buttonText="Shop now!"/>
                    </div>
                </div>
                <div className="w-full border-t border-gray-200">
                    <h2 className="font-bold py-4">You might also like</h2>
                    <div className="mt-6 grid gap-2 md:gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
                        
                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>


                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>


                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>


                            <Product product={products[Math.floor(Math.random() * products?.length)]}/>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <BigAd dark minorHeading="Holiday sale!" majorHeading="Supplies limited" text="Lorem ipsum dolor sit amet ipsum dolor sit amet" route={HomePath + "/shop"} buttonText="Shop now!" />
    </>
  )
}
